import { useEffect, useRef, useState } from "react";
import "./index.less";

const SpeakerItem: React.FC<{
  speakerItem: string;
  summaryEditing?: boolean;
  handleDelSpeaker: () => void;
  handleSpeakerInput: (value: string) => void;
  maxLength?: number;
}> = ({
  speakerItem,
  summaryEditing,
  handleDelSpeaker,
  handleSpeakerInput,
  maxLength = 7,
}) => {
  const divRef = useRef<HTMLDivElement>(null);

  const [initSpeakerItem, setInitSpeakerItem] = useState(speakerItem);
  const [isFocus, setFocus] = useState(false);
  const isComposing = useRef(false);
  const cursorPositionRef = useRef(0);

  // 进入编辑后，不再跟随数据更新
  useEffect(() => {
    if (!isFocus) {
      setInitSpeakerItem(speakerItem);
    }
  }, [isFocus, speakerItem]);

  const onFocus = () => {
    setFocus(true);
  };

  const onBlur = () => {
    setFocus(false);
  };

  // 删除责任人
  const handleSpeakerKeyDown = (
    currentValue: string,
    e: React.KeyboardEvent<HTMLDivElement>
  ) => {
    if (e.key === "Backspace" && currentValue.trim() === "") {
      handleDelSpeaker();
      divRef.current?.blur();
    }
    if (e.key === "Enter") {
      e.preventDefault();
      divRef.current?.blur();
    }
  };

  const restoreSelection = () => {
    const targetDiv = divRef.current as HTMLDivElement;
    if (targetDiv && targetDiv.firstChild) {
      const range = document.createRange();
      const selection = window.getSelection();
      range.setStart(
        targetDiv.firstChild,
        Math.min(cursorPositionRef.current, maxLength)
      );
      range.setEnd(
        targetDiv.firstChild,
        Math.min(cursorPositionRef.current, maxLength)
      );
      // 应用选区
      selection?.removeAllRanges();
      selection?.addRange(range);
    }
  };

  const onInput = () => {
    if (!divRef.current || isComposing.current) return;

    if (divRef.current.innerText.length > maxLength) {
      const selection = window.getSelection();
      const range = selection?.getRangeAt(0);
      if (!range) return;
      cursorPositionRef.current = range.startOffset;
      divRef.current.innerText = divRef.current?.innerText.slice(0, maxLength);
      restoreSelection();
    }
    handleSpeakerInput(divRef.current?.innerText || "");
  };

  const handleCompositionStart = () => {
    isComposing.current = true;
  };

  const handleCompositionEnd = () => {
    isComposing.current = false;
    onInput();
  };

  const showPlaceholder = !divRef.current?.innerText.trim().length;

  return (
    <span
      onKeyDown={(e) => {
        handleSpeakerKeyDown(
          divRef.current?.innerText || "",
          e as React.KeyboardEvent<HTMLDivElement>
        );
      }}
      onInput={onInput}
      ref={divRef}
      onFocus={onFocus}
      onBlur={onBlur}
      onCompositionStart={handleCompositionStart}
      onCompositionEnd={handleCompositionEnd}
      contentEditable={summaryEditing}
      className={`${
        showPlaceholder ? "speaker-item-placeholder" : ""
      } inline-block whitespace-nowrap min-w-7.25 focus-caret-mx-primary mr-2  bg-#BDC9DB29/16 rounded-25 px-2 h-5.5 lh-5.5 text-mx-tertiary text-3.25 focus:outline-none`}
    >
      {initSpeakerItem}
    </span>
  );
};
export default SpeakerItem;
